exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ttf[data-v-6ed60ef4]{\r\n  font-size: 50px;\r\n  font-family: 'hwxk';\n}\n.myCanvas[data-v-6ed60ef4]{\r\n  border: 1px solid #DCDFE6;\r\n  border-radius: 4px;\n}\n.preview[data-v-6ed60ef4]{\r\n  font-size: 40px;\r\n  color: #0f63de;\n}\n.ruleForm[data-v-6ed60ef4]{\r\n  width: 420px;\n}\r\n", ""]);

// exports
